export default __webpack_public_path__ + "static/media/christensen.ec813d77.jpg";